import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { API_URL, IMAGE_URL, objectToParams } from 'app/constants';
import { EnrollSessionService } from 'app/shared/enrollSession.service';

@Component({
  selector: 'app-purium-and-sustainability',
  templateUrl: './purium-and-sustainability.component.html',
  styleUrls: ['./purium-and-sustainability.component.scss']
})
export class PuriumAndSustainabilityComponent implements OnInit {
  IMAGE_URL = IMAGE_URL;
  purium_reviews = [];
  own_reviews = [];
  addOnProducts = [];
  currentSlideIndex: number = 0;
  public slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  constructor(public _enrollSession: EnrollSessionService,private router:Router) { }

  ngOnInit(): void {

    this.purium_reviews = [
       {review_heading: "a proven glyphosate solution",review_text: "I've tried the many gut support products on the market. When Biome Medic launched in 2018, I haven't needed to look elsewhere. I immediately knew I could sustain my healthy gut balance ongoing with it!",name:"Carmela"},
       {review_heading: "biome medic",review_text: "This product has helped to restore my gut health, and reduced pain my body pain to almost nil. My food tolerance and regularity have improved.",name:"Echobar"},
       {review_heading: "life changing",review_text: "I had all kinds of discomforts, bloating, and digestive issues until trying [Biome Medic]. Obsessed is underrated . . . Biome Medic has aided in my digestion process. I take it first thing in the morning . . . I do not experience bloating and discomfort anymore. These products are amazing!",name:"Rosina"},
       {review_heading: "it really works!",review_text: "Within one month, I've seen a good difference in my gut health worth biome medic!",name:"Tabitha"},
       {review_heading: "toxins",review_text: "Biome Medic, simply put, is a GREAT product. We all have Glyphosate in our body, and to have a gold standard formula that removes it from our body is simply the best.",name:"Sharyn"},
       {review_heading: "biome medic",review_text: "Can't say enough about this product. It is part of my life, and I can't seem to live without it. My body is hooked!",name:"Maria"}
    ]

    this.own_reviews = [
      {review:'"We don’t just nourish bodies; we nurture the planet. Purium’s plastic-free packaging is our pledge to a greener future."'},
      {review:'“Purium proves that clean ingredients deserve clean packaging. No plastic, no waste—just pure sustainability.”'},
      {review: '"Wellness should never come at the cost of the environment. Purium proves that nourishing yourself and protecting the Earth can go hand in hand."'}
    ]

    this.addOnProducts = [
       {product_image: 'assets/images/purium-sustainability/cant-beet-this-product.png', product_desc:{heading:"Can't Beet This! 15-30 Servings",para:"Power up performance naturally without the jitters from highly caffeinated alternatives! This delicious organic fruity tasting beetroot formula delivers oxygen and nutrients for sustained energy and maximum strength. A must have for any active lifestyle, Can’t Beet This is a great source of nitrates for nitric oxide conversion, supports circulation and endurance.",itemCode:2750 } },
       {product_image: 'assets/images/purium-sustainability/pineal-clear-product.png', product_desc:{heading:"Pineal Clear",para:"Pineal Clear is a unique formula created to support a healthy pineal gland, one of the nine hormone-producing glands in our endocrine system. Lifestyle factors and age can lead to calcification of the tiny gland, often referred to as the 'seed of the soul, which produces the critical hormone melatonin, supports healthy sleep and circadian cycles and many believe aids in forming deeper connections.",itemCode:2140 } },
       {product_image: 'assets/images/purium-sustainability/meno-positive-product.png', product_desc:{heading:"Meno-Positive",para:"At Purium, we know balance is everything. Purium formulated Meno-Positive, a synergistic blend of Chaste Tree Berry, Dong Quai Root, White American Ginseng, Red Clover Aerial Parts, and Black Cohosh Root, to help women feel their best during hormonal fluctuations.",itemCode:2160 } },
       {product_image: 'assets/images/purium-sustainability/zinc-ade-product.png', product_desc:{heading:"ZinC-ADE",para:"ZinC-ADE delivers specific, targeted, plant-sourced nutrients (Zinc and Vitamins A, C, D & E) to support a healthy terrain throughout the body while keeping with Purium’s pure, whole-food approach to immune support.",itemCode:2520 } }
    ]

    document.addEventListener("DOMContentLoaded", function () {
      const tabs = document.querySelectorAll(".tab");
      const contents = document.querySelectorAll(".tab-content");
      tabs.forEach(tab => {
          tab.addEventListener("click", function () {
              tabs.forEach(t => t.classList.remove("active"));
              contents.forEach(c => c.classList.remove("active"));
              this.classList.add("active");
              document.getElementById(this.dataset.tab).classList.add("active");
          });
      });
    });
  }

  RedirectToHome(){
    this.router.navigate(['/']);
  }

  getCurrentSlide(event) {
    this.currentSlideIndex = event?.currentSlide;
  }

}
